import { render, staticRenderFns } from "./ViewPayrun.vue?vue&type=template&id=5fcdfe1f&scoped=true"
import script from "./ViewPayrun.vue?vue&type=script&lang=js"
export * from "./ViewPayrun.vue?vue&type=script&lang=js"
import style0 from "./ViewPayrun.vue?vue&type=style&index=0&id=5fcdfe1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcdfe1f",
  null
  
)

export default component.exports